const AUTH_TOKEN = 'dynamic_authentication_token';
const AUTH_USER = 'dynamic_authenticated_user';
const LAST_USED_WALLET = 'dynamic_last_used_wallet';
const NETWORKS_STORAGE_KEY = 'dynamic_networks';
const NONCE_STORAGE_KEY = 'dynamic_nonce';
const PRIMARY_WALLET_ID = 'dynamic_primary_wallet_id';
const PROJECT_SETTINGS_STORAGE_KEY = 'dynamic_project_settings';
const WALLET_PICKER_SEARCH_KEY = 'dynamic_wallet_picker_search';
const NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY = 'dynamic_newtoweb3_wallet_extension_installed';
const CONNECTED_WALLET_CONNECTOR_DATA = 'dynamic_connected_wallet_connector';
const AUTH_MODE = 'dynamic_auth_mode';

export { AUTH_MODE, AUTH_TOKEN, AUTH_USER, CONNECTED_WALLET_CONNECTOR_DATA, LAST_USED_WALLET, NETWORKS_STORAGE_KEY, NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY, NONCE_STORAGE_KEY, PRIMARY_WALLET_ID, PROJECT_SETTINGS_STORAGE_KEY, WALLET_PICKER_SEARCH_KEY };
